import Component from '@glimmer/component';

interface IArgs {
  text?: string;
}
export default class BvRichText extends Component<IArgs> {
  get textParts() {
    return this.args.text?.split('\n');
  }
}
